import { call, customEvent } from "goi_common";

import { ParlorHeader } from "@/containers/ParlorDetailContainer/components/ParlorHeader";
import { QuoteWhyDifferent } from "@/containers/QuoteLandingContainer/components/QuoteWhyDifferent";
import { GOI_PHONE } from "@/constants/contact";

import { CommonQuoteHero } from "./components/CommonQuoteHero";
import { CommonQuoteCostGuide } from "./components/CommonQuoteCostGuide";
import { CommonQuoteCta } from "./components/CommonQuoteCta";
import { CommonQuoteCtaBottom } from "./components/CommonQuoteCtaBottom";

/**
 * 네이버 검색광고 비즈채널용 공통 견적 LP
 * - URL: parlor.goifuneral.co.kr/quote/
 * - 광고 노출 키워드: 지역별 "{지역}장례식장" (김해/대구/인천/울산/양산/수원/성남/부산)
 * - 페이지는 단일 (공통). 지역 구분은 utm으로만
 * - CTA: www.goifuneral.co.kr/match/request/?{원본 utm 보존}
 *
 * 기존 `/place/[id]/quote`와의 차이:
 * - 장례식장별 정보 X (일반 안내)
 * - 비용 데이터: 평균 범위 (장례식장 실 비용 X)
 * - CTA 목적지: /match/request (parlor_id 없음)
 */
export const CommonQuoteLandingContainer = () => {
  return (
    <>
      <ParlorHeader
        hidePhoneStrip
        showNav={false}
        showPhoneCta
        onPhoneCtaClick={() => {
          customEvent({
            newGtm: {
              path: "funeral_cost_ad",
              trigger_and_target: "btn_phone_header",
            },
          });
          call(GOI_PHONE);
        }}
      />
      <main className="lp">
        <CommonQuoteHero />
        <CommonQuoteCostGuide />
        <CommonQuoteCta />
        <div className="lp-divider" />
        <QuoteWhyDifferent>
          <CommonQuoteCtaBottom />
        </QuoteWhyDifferent>
      </main>
    </>
  );
};
